import cep from './formatCEP'
import cnpj from './formatCNPJ'
import cpf from './formatCPF'
import phone from './formatPhone'
import date from './formatDate'
import time from './formatHours'
import card from './formatCard'
import monetary from './formatMonetary'
import monetaryDollar from './formatMonetaryDollar'
import monetaryEuro from './formatMonetaryEuro'
import number from './formNumber'
import double from './formDouble'
import porcentagem from './porcentagem'
import nif from './formatNif'
import nre from './formatNre'
import def from './any'
import passport from './formatPassport'
import utente from './formatUtente'

export default {
  cep,
  cnpj,
  cpf,
  phone,
  date,
  time,
  card,
  monetary,
  number,
  monetaryDollar,
  monetaryEuro,
  double,
  porcentagem,
  nif,
  nre,
  def,
  passport,
  utente
}
